export const useAlgoliaApi = () => {
  const search = <T>(
    algoliaIndex: string,
    queryParams: any,
    mergeB2C?: boolean,
    bestSelling?: boolean,
  ) => {
    return $fetch<T>(`/api/algoliaSearch`, {
      query: {
        queryParams,
        algoliaIndex,
        mergeB2C,
        bestSelling,
      },
    })
  }
  return { search }
}
